// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__37whQ","file":"styles_file__2biZP"};